// 用户事件监听 Hook

import { useEvent } from "../../../hooks/useEvent";
import { useUserStore } from "../stores";
import { Message } from "../../../components";
import { triggerPopup } from "../../../utils/popupTriggers";
import { POPUP_IDS } from "../../../config/popupConfig";
import { loadConfig } from "../../index";

/**
 * 用户事件监听 Hook
 * 监听来自 WebSocket 的用户相关事件
 */
export function useUserEvents() {
  const { isAuthenticated, loadUserInfo } = useUserStore(state => ({
    isAuthenticated: state.isAuthenticated(),
    loadUserInfo: state.loadUserInfo,
  }));

  useEvent("event", async data => {
    console.log("[useUserEvents] 收到事件数据:", data);
    // 重新加载用户信息
    if (!isAuthenticated) {
      console.log("[useUserEvents] 用户未认证，跳过处理");
      return;
    }

    // 获取事件类型
    const event = data && data.data && data.data.event;

    if (event === "RECHARGE_SUCCESS") {
      Message.success(`Recharge Success`, 2000);
      // 充值成功后重新加载配置，刷新七日充值活动数据
      try {
        await loadConfig();
        console.log("[useUserEvents] 充值成功，已重新加载配置");
      } catch (error) {
        console.error("[useUserEvents] 重新加载配置失败:", error);
      }
    }
    if (event === "PROMOTION") {
      if (data.data.extra?.type === "DAILY_RECHARGE") {
        setTimeout(() => {
          triggerPopup(POPUP_IDS.SEVEN_DAY_RECHARGE);
        }, 500);
      }
    }

    try {
      await loadUserInfo();
    } catch (error) {
      console.error("[useUserEvents] 重新加载用户信息失败:", error);
    }
  });
}
